import handleMoveViewBox from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/reducers/handleMoveViewBox';

export default (state, { payload }) => {
    const { mouseDown } = state;

    if (mouseDown !== null) {
        return handleMoveViewBox(
            state,
            {
                payload: {
                    x: mouseDown.x - payload.x,
                    y: mouseDown.y - payload.y,
                },
            },
        );
    }

    return state;
};
